import { offerTypes, discountTypes } from "../OfferType/offerTypeConstants";

/**
 * Build all room/rate plan combination objects.
 * Pure function — previously a useCallback with [] deps.
 */
export function buildAllRoomRateplanCombos(roomsData = [], ratePlansData = []) {
  const combos = [];
  roomsData.forEach((room) => {
    ratePlansData.forEach((rp) => {
      if (room?.code && rp?.code) {
        combos.push({
          mRight: room.code,
          mLeft: rp.code,
          rateplanId: rp.id,
          roomtypeId: room.id,
        });
      }
    });
  });
  return combos;
}

/**
 * Compute the total discount value from a discountVO object.
 * Used by both useOfferTypeState (as getDiscountValue) and OfferType (as getDiscountValueForEntry).
 */
export function computeDiscountValue(discountVO) {
  const isPercent = discountVO.mCompDiscountType === offerTypes[0].value;
  const isDayWise = discountVO.discountType === discountTypes[1].value;

  if (isPercent) {
    if (isDayWise) {
      return Object.values(discountVO.percentDiscountMap).reduce(
        (total, d) => total + d,
        0
      );
    }
    return discountVO.percentDiscountAmount ?? 0;
  }

  if (isDayWise) {
    return Object.values(discountVO.fixedDiscountMap).reduce(
      (total, d) => total + d,
      0
    );
  }
  return discountVO.fixedDiscountAmount ?? 0;
}
